/**
 * Check if the browser is in full screen mode
 * @returns `true` if in full screen
 */
export const isFullScreen = () => {
	return (
		(document.fullscreenElement ||
			(document as any).webkitFullscreenElement ||
			(document as any).mozFullScreenElement) != null
	);
};
